














import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class TextBox extends Vue {
  @Prop({ default: '' }) public title?: string;
  @Prop({ default: '' }) public value?: string;
  @Prop({ default: '' }) public placeholder?: string;

  @Prop({ default: null }) public length?: number;
  @Prop({ default: false }) public required?: boolean;
  @Prop({default:false}) public keyfield: boolean;      
  @Prop({ default: null }) public regex: string;
  @Prop({ default: null }) public regexMessage: string;
  @Prop({ default: 1 }) public rows: number;

  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;  
  @Prop() public tooltip: string;
  @Prop() public linkFormat: string;
  @Prop({ default: false }) public isPassword: boolean;

  public isEdit: boolean = true;
  public validator: Components.ControlValidator;
  
  public get value2(){
    return this.value && this.isPassword ? this.value.replace(/./g,'*'): this.value;
  }
  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  mounted() {
    this.validator.update();
  }
  public get internalValue(): string {
    return this.value;
  }
  // public get readValue():string{
  //   return this.value.replace(/\r?\n/g,'<br>');
  // }
  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.validator.update();
  }

  public internalValidate(): string {
    const value = this.internalValue;
    if (this.required && (value == undefined || value == null || value.length == 0)) {
      return '必須項目です';
    }
    if (this.length != undefined && value != undefined && value != null && value.length > this.length) {
      return '入力可能な文字数は' + this.length + '文字です';
    }
    //正規表現チェックは文字入力がある場合のみ適用
    if (this.regex != undefined && value != null && value.length > 0) {
      if (value.match(this.regex) == null) {
        return this.regexMessage;
      }
    }

    return '';
  }

  public onLinkClicked(){
    if (this.linkFormat){
      this.$router.push(String.format(this.linkFormat, this.value));       
    }
  }      
}
